import { useState, useRef, useEffect } from 'react';
import { Popover } from '@material-ui/core';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import Styles from './FilterPopover.scss';
import styles from './Toolbar.scss';
import { toobarTheme } from './ToolbarUtils';
import DateTimePicker from '../DateTime/DateTimePicker';
import Fade from '@material-ui/core/Fade';
import { getLocalDateNoTime } from '../../util/dateTime';
import { Button } from '../../../components/common/Button/Button';
import { Radio } from '@material-ui/core';

export const FilterState = {
    'DEFAULT': 'default',
    'SINGLELIST': 'singleList',
    'MULTILIST': 'multiList',
    'SINGLESEARCHLIST': 'singleSeachList',
    'MULTISEARCHLIST': 'multiSearchList',
    'DATEFILTER': 'dateFilter'
};

function updateCustomizedColumns(showCustomize, toUpdateFilter) {
    if (showCustomize.length) {
        const selectedFilters = Object.keys(toUpdateFilter.filter).filter(key => toUpdateFilter.filter[key].length > 0);
        const updatedItems = toUpdateFilter.customizedColumns.map(column => {
            if (
                (selectedFilters.includes(column.key) ||
                    (column.key === 'activation_date' && selectedFilters.includes('activationDate')) ||
                    (column.key === 'renewal_date' && selectedFilters.includes('renewalDate'))) &&
                !column.checked
            ) {
                return { ...column, checked: true };
            } else {
                return column;
            }
        });
        return updatedItems;
    }
    return toUpdateFilter.customizedColumns;
}

const FilterPopover = ({ id, open, anchorEl, handleClose, defaultFilterFields, filterValue, setFilterValue, onChangeFilter, dataCy, showCustomize, setShowCustomize }) => {

    const [filterItemDetail, setFilterItemDetail] = useState({});
    const [searchInput, setSearchInput] = useState('');
    const [searchFilteredList, setSearchFilteredList] = useState([]);
    const searchInputRef = useRef(null);


    const theme = createTheme(toobarTheme);

    const DefaultFilterContent = () => {
        const onListItemClick = (item) => {
            setFilterItemDetail(item);
        };
        return (
            <div className={Styles.defaultFilterContainer} data-cy={`${dataCy}-default-filter`}>
                {defaultFilterFields.map((i, index) =>
                    <div className={Styles.filterOptionItem} key={index} onClick={() => onListItemClick(i)}>
                        <span>
                            {i.label}
                        </span>
                        <FontAwesomeIcon icon={faChevronRight} className={Styles.filterListIcon} />
                    </div>
                )}

            </div>
        );
    };
    const MultiSelectListFilterContent = () => {

        const goBackToDefaultList = () => {
            setFilterItemDetail({});
        };
        const onChange = ((event, item) => {
            let toUpdateFilter = { ...filterValue };
            if (event.target.checked) {
                toUpdateFilter.filter[filterItemDetail.key].push(item.key);
            }
            else {
                let valueToRemove = toUpdateFilter.filter[filterItemDetail.key].indexOf(item.key);
                toUpdateFilter.filter[filterItemDetail.key].splice(valueToRemove, 1);
            }
            if (showCustomize.length) {
                const updatedItems = updateCustomizedColumns(showCustomize, toUpdateFilter);
                setShowCustomize(updatedItems);
            }
            onChangeFilter(toUpdateFilter);

        });

        const handleNestedDivClick = (item) => {
            onChange({ target: { checked: !isChecked(item) } }, item);
        };

        const isChecked = (item) => {
            if (filterValue.filter[filterItemDetail.key].includes(item.key))
                return true;

        };
        return (
            <div className={Styles.defaultFilterContainer} data-cy={`${dataCy}-multi-filter`}>
                <div className={`${Styles.filterHeader}`} >
                    <FontAwesomeIcon icon={faChevronLeft} className={Styles.filterBackIcon} onClick={goBackToDefaultList} />
                    <span className={Styles.filterHeaderText}>
                        {filterItemDetail.label}
                    </span>
                </div>
                <div className={filterItemDetail.label === 'Responsibilities' ? Styles.responsibilitiesContainer : Styles.normalFilterContainer}>
                    {
                        filterItemDetail.list.map((i, index) => (
                            <div
                                className={`${Styles.filterOptionItem} ${Styles.clickableDiv} ${Styles.checkboxLabel}`}
                                key={index}
                                onClick={() => handleNestedDivClick(i)}
                            >
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="checked"
                                                color="primary"
                                                checked={isChecked(i)}
                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                            />
                                        }
                                        label={i.label}
                                    />
                                </FormGroup>
                            </div>
                        ))
                    }
                </div>
            </div >
        );
    };
    const MultiSearchListFilterContent = () => {

        useEffect(() => {
            if (searchInputRef.current) {
                searchInputRef.current.focus();
            }
        }, [filterItemDetail]);


        const goBackToDefaultList = () => {
            setFilterItemDetail({});
        };

        const onChange = ((event, item) => {
            let toUpdateFilter = { ...filterValue };
            if (event.target.checked) {
                toUpdateFilter.filter[filterItemDetail.key].push(item.key);
            } else {
                let valueToRemove = toUpdateFilter.filter[filterItemDetail.key].indexOf(item.key);
                toUpdateFilter.filter[filterItemDetail.key].splice(valueToRemove, 1);
            }
            if (showCustomize.length) {
                const updatedItems = updateCustomizedColumns(showCustomize, toUpdateFilter);
                setShowCustomize(updatedItems);
            }

            onChangeFilter(toUpdateFilter);
        });

        const handleNestedDivClick = (item) => {
            onChange({ target: { checked: !isChecked(item) } }, item);
        };

        const isChecked = (item) => {
            if (filterValue.filter[filterItemDetail.key].includes(item.key)) {
                return true;
            }
        };

        const onChangeSearch = (searchText) => {
            setSearchInput(searchText);
            const searchFilteredList = filterItemDetail.list.filter(item =>
                item.label.toLowerCase().includes(searchText.toLowerCase())
            );
            setSearchFilteredList(searchFilteredList);
        };

        const renderFilterOption = (item, index) => (
            <div
                className={`${Styles.filterOptionItem} ${Styles.clickableDiv} ${Styles.checkboxLabel}`}
                key={index}
                onClick={() => handleNestedDivClick(item)}
            >
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="checked"
                                color="primary"
                                checked={isChecked(item)}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            />
                        }
                        label={item.label}
                    />
                </FormGroup>
            </div>
        );


        return (
            <div className={Styles.defaultFilterContainer} data-cy={`${dataCy}-multi-filter`}>
                <div className={`${Styles.filterHeader}`}>
                    <FontAwesomeIcon icon={faChevronLeft} className={Styles.filterBackIcon} onClick={goBackToDefaultList} />
                    <span className={Styles.filterHeaderText}>
                        {filterItemDetail.label}
                    </span>
                </div>
                {filterItemDetail.list.length !== 0 &&
                    <div className={Styles.filterSearchBarContainer}>
                        <span className={styles.Toolbar__searchBoxContainer} data-cy={`${dataCy}-search`}>
                            <FontAwesomeIcon icon={faSearch} className={styles.Toolbar__searchIcon} />
                            <input className={styles.Toolbar__inputText}
                                ref={searchInputRef}
                                type="text"
                                placeholder={`Search ${filterItemDetail.label}s`}
                                onChange={(e) => onChangeSearch(e.target.value)}
                                value={searchInput}
                                data-cy="SearchBar-SearchTeam" />
                            {searchInput !== '' &&
                                <FontAwesomeIcon icon={faTimes} className={styles.Toolbar__clearIcon} onClick={() => setSearchInput('')} />}
                        </span>
                    </div>}
                <div className={filterItemDetail.label === 'Responsibilities' ? Styles.responsibilitiesContainer : Styles.normalFilterContainer}>
                    {searchInput !== '' && searchFilteredList.length === 0 ? (
                        <div className={Styles.noSearchResultContainer}>
                            <p className={Styles.noSearchResultText}>No {filterItemDetail.label}s match your search.</p>
                        </div>
                    ) : (
                        searchInput !== '' ?
                            searchFilteredList.map(renderFilterOption) :
                            filterItemDetail.list.length !== 0 ?
                                filterItemDetail.list.map(renderFilterOption) :
                                <div className={Styles.noSearchResultContainer}>
                                    <p className={Styles.noSearchResultText}>No {filterItemDetail.label}s found.</p>
                                </div>
                    )}
                </div>
            </div>
        );
    };

    const CustomDateFilters = (props) => {
        const [onDate, setOnDate] = useState(undefined);
        const [fromDate, setFromDate] = useState(undefined);
        const [toDate, setToDate] = useState(undefined);
        const [customHeightWidth, setCustomHeightWidth] = useState({ on: false, from: false, to: false });
        const [selectedRadio, setSelectedRadio] = useState('on');

        const handleRadioChange = (value) => {
            setSelectedRadio(value);
            setOnDate(undefined);
            setFromDate(undefined);
            setToDate(undefined);
        };

        const onDateChange = (value, setHook) => {
            setHook(value);
        };

        const setCustomHeightWidthFunction = (label) => {
            setCustomHeightWidth(prevState => ({
                on: label === 'on',
                from: label === 'from',
                to: label === 'to',
            }));
        };

        const setCustomDate = () => {
            if (selectedRadio === 'on') {
                props.onCustomDateChange(onDate, true);
            }
            else {
                props.onCustomDateChange(`${fromDate} to ${toDate}`, true);
            }
        };

        const handleCancel = () => {
            handleClose();
        };

        return (
            <div className={Styles.customDateFilterContainer}>
                <div style={{ width: (customHeightWidth.on || customHeightWidth.from || customHeightWidth.to) && '650px', height: (customHeightWidth.on || customHeightWidth.from || customHeightWidth.to) && '300px' }} className={Styles.borderBottomClass}>
                    <div className={Styles.filterRow}>
                        <Radio color="primary" checked={selectedRadio === 'on'} onChange={() => handleRadioChange('on')} />
                        <div className={Styles.fromLabel}>On&nbsp;&nbsp;&nbsp;&nbsp;</div>
                        <div className={`${Styles.defaultFilterContainerCustomDateFilter} ${Styles.withPadding}`} data-cy={`${dataCy}-multi-filter`}>
                            <DateTimePicker
                                className={Styles.DatePicker}
                                autoFocus={false}
                                time={false}
                                noTimezone={true}
                                id='onDate'
                                name='onDate'
                                value={onDate}
                                disabled={selectedRadio !== 'on'}
                                onClick={() => selectedRadio === 'on' && setCustomHeightWidthFunction('on')}
                                onChange={(value) => onDateChange(value && getLocalDateNoTime(value).toISOString(), setOnDate)}
                                max={new Date(2099, 11, 31)}
                            />
                        </div>
                    </div>

                    <div className={Styles.filterRow}>
                        <Radio color="primary" checked={selectedRadio === 'from'} onChange={() => handleRadioChange('from')} />
                        <div className={Styles.fromLabel}>From</div>
                        <div className={`${Styles.defaultFilterContainerCustomDateFilter} ${Styles.withPadding}`} data-cy={`${dataCy}-multi-filter`}>
                            <DateTimePicker
                                className={Styles.DatePicker}
                                autoFocus={false}
                                time={false}
                                noTimezone={true}
                                id='fromDate'
                                name='fromDate'
                                value={fromDate}
                                disabled={selectedRadio !== 'from'}
                                onClick={() => selectedRadio === 'from' && setCustomHeightWidthFunction('from')}
                                onChange={(value) => onDateChange(value && getLocalDateNoTime(value).toISOString(), setFromDate)}
                                max={new Date(2099, 11, 31)}
                            />
                        </div>
                        <div className={Styles.dateFilterLabel}>to</div>
                        <div className={`${Styles.defaultFilterContainerCustomDateFilter} ${Styles.withPadding}`} data-cy={`${dataCy}-multi-filter`}>
                            <DateTimePicker
                                className={Styles.DatePicker}
                                autoFocus={false}
                                time={false}
                                noTimezone={true}
                                id='toDate'
                                name='toDate'
                                value={toDate}
                                disabled={selectedRadio !== 'from'}
                                onClick={() => selectedRadio === 'from' && setCustomHeightWidthFunction('to')}
                                onChange={(value) => onDateChange(value && getLocalDateNoTime(value).toISOString(), setToDate)}
                                max={new Date(2099, 11, 31)}
                            />
                        </div>
                    </div>
                </div>

                <div className={Styles.buttonRow}>
                    <Button className={Styles.cancelButton} onClick={handleCancel}>Cancel</Button>
                    <Button className={Styles.applyButton} onClick={() => setCustomDate()}
                        disabled={selectedRadio === 'on' ? !onDate : (!fromDate || !toDate)} >Apply</Button>
                </div>
            </div>
        );
    };


    const DateFilterContent = () => {

        const [showCustomDateFilter, setShowCustomDateFilter] = useState(false);
        const defaultActivationDateLabels = ['This Week', 'This Month', 'This Year', 'Past 7 Days', 'Past 30 Days', 'Past Year'];
        const defaultRenewalDateLabels = ['This Week', 'This Month', 'This Year', 'Next 7 Days', 'Next 30 Days'];


        const goBackToDefaultList = () => {
            showCustomDateFilter ? setShowCustomDateFilter(false) : setFilterItemDetail({});
        };

        const pastRenewalDate = () => {
            let toUpdateFilter = { ...filterValue };
            const key = 'renewalDate';
            if (toUpdateFilter.filter[key].includes(key)) {
                toUpdateFilter.filter[key] = ['Past Renewal Date'];
            } else {
                toUpdateFilter.filter[key] = ['Past Renewal Date'];
            }
            if (showCustomize.length) {
                const updatedItems = updateCustomizedColumns(showCustomize, toUpdateFilter);
                setShowCustomize(updatedItems);
            }

            onChangeFilter(toUpdateFilter);
            handleClose();
        };

        const handleNestedDivClick = (item, isCustomDate) => {
            let toUpdateFilter = { ...filterValue };

            if (isCustomDate) {
                if (toUpdateFilter.filter[filterItemDetail.key].includes(item)) {
                    toUpdateFilter.filter[filterItemDetail.key] = [formatDate(item)];
                } else {
                    toUpdateFilter.filter[filterItemDetail.key] = [formatDate(item)];
                }
            } else {
                if (toUpdateFilter.filter[filterItemDetail.key].includes(item.key)) {
                    toUpdateFilter.filter[filterItemDetail.key] = [item.key];
                } else {
                    toUpdateFilter.filter[filterItemDetail.key] = [item.key];
                }
            }
            if (showCustomize.length) {
                const updatedItems = updateCustomizedColumns(showCustomize, toUpdateFilter);
                setShowCustomize(updatedItems);
            }

            onChangeFilter(toUpdateFilter);
            handleClose();
        };

        const formatDate = (dateString) => {
            const dateParts = dateString.split(' to ');
            const months = [
                'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
            ];

            if (dateParts.length === 2) {
                const startDate = new Date(dateParts[0]);
                const endDate = new Date(dateParts[1]);

                const startDay = startDate.getDate();
                const startMonthIndex = startDate.getMonth();
                const startYear = startDate.getFullYear();

                const endDay = endDate.getDate();
                const endMonthIndex = endDate.getMonth();
                const endYear = endDate.getFullYear();

                return `${startDay} ${months[startMonthIndex]} ${startYear} to ${endDay} ${months[endMonthIndex]} ${endYear}`;
            } else {
                const date = new Date(dateString);
                const day = date.getDate();
                const monthIndex = date.getMonth();
                const year = date.getFullYear();

                return `${day} ${months[monthIndex]} ${year}`;
            }
        };


        const renderFilterItem = (item, index) => {
            return filterItemDetail.label === 'Activation Date' ? (
                <div
                    className={`${index === 2 || index === 5 ? Styles.borderBottomClass : ''} ${Styles.dateOptionItem}`}
                    key={index}
                    onClick={() => handleNestedDivClick(item, false)}
                >
                    <span>{defaultActivationDateLabels[index]}</span>
                    <span>{item.label}</span>
                </div>
            ) : (
                <div
                    className={`${index === 2 || index === 4 ? Styles.borderBottomClass : ''} ${Styles.dateOptionItem}`}
                    key={index}
                    onClick={() => handleNestedDivClick(item, false)}
                >
                    <span>{defaultRenewalDateLabels[index]}</span>
                    <span>{item.label}</span>
                </div>
            );

        };



        return (
            <div className={Styles.defaultFilterContainer} data-cy={`${dataCy}-multi-filter`}>
                <div className={`${Styles.filterHeader}`} >
                    <FontAwesomeIcon icon={faChevronLeft} className={Styles.filterBackIcon} onClick={goBackToDefaultList} />
                    <span className={Styles.filterHeaderText}>
                        {showCustomDateFilter ? filterItemDetail.label + ' | Custom Range' :
                            filterItemDetail.label}
                    </span>
                </div>
                {!showCustomDateFilter && <div className={filterItemDetail.label === 'Responsibilities' ? Styles.responsibilitiesContainer : Styles.normalFilterContainer}>
                    {filterItemDetail.label !== 'Activation Date' &&
                        <div className={`${Styles.dateOptionItem} ${Styles.borderBottomClass}`} onClick={() => pastRenewalDate()}>
                            <span>
                                Past Renewal Date
                            </span>
                        </div>
                    }
                    {filterItemDetail.list.map((item, index) => renderFilterItem(item, index))}
                    <div
                        className={Styles.dateOptionItem}
                        onClick={() => setShowCustomDateFilter(true)}
                    >
                        <span>
                            Custom Range
                        </span>
                        <span>
                            <FontAwesomeIcon icon={faChevronRight} className={Styles.filterListIcon} />
                        </span>
                    </div>
                </div>}

                {showCustomDateFilter && <CustomDateFilters goBack={goBackToDefaultList} onCustomDateChange={handleNestedDivClick} />}

            </div>
        );
    };




    const LoadFilterContent = () => {
        switch (filterItemDetail.type) {
            case FilterState.MULTILIST:
                return (<MultiSelectListFilterContent />);
            case FilterState.MULTISEARCHLIST:
                return (<MultiSearchListFilterContent />);
            case FilterState.DATEFILTER:
                return (<DateFilterContent />);
            default:
                return (<DefaultFilterContent />);
        }
    };
    const handleFilterClose = () => {
        handleClose();
    };
    const handleExited = () => {
        setFilterItemDetail({});
        setSearchInput('');
    };
    return (
        <ThemeProvider theme={theme}>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleFilterClose}
                TransitionComponent={Fade}
                TransitionProps={{ onExited: handleExited }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                <LoadFilterContent />
            </Popover >
        </ThemeProvider>
    );
};
export default FilterPopover;